import { render } from "./SegmentosProdView.vue?vue&type=template&id=11a09aa8&scoped=true"
import script from "./SegmentosProdView.vue?vue&type=script&lang=js"
export * from "./SegmentosProdView.vue?vue&type=script&lang=js"

import "./SegmentosProdView.vue?vue&type=style&index=0&id=11a09aa8&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD24\\Desenvolvimento\\Corofergs\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11a09aa8"]])

export default __exports__